<template>
    <b-form-group
            class="c-text"
            :description="description"
            :label="label"
            :label-for="id"
            :label-cols="labelCols"
            :aria-describedby="id + '_InvalidFeedback'">
      <b-form-input
              v-if="required"
              :type="dataType"
              :id="id"
              :state="chkState(id)"
              v-model="dataValue"
              :placeholder="placeholder"
              autocomplete="off"></b-form-input>
        <b-form-input
                v-else
                :type="dataType"
                :id="id"
                v-model="dataValue"
                :placeholder="placeholder"
                autocomplete="off"></b-form-input>
      <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
        {{invalidFeedbackMessage}}
      </b-form-invalid-feedback>
        <b-button v-if="autoGenerateOption" @click="generate" class="btn btn-info mt-2">{{window.Core.Definition.getDefinition('Générer un mot de passe')}}</b-button>
    </b-form-group>
</template>

<script>
  export default {
      name: 'InputPassword',
      props: {
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: String,
              default: ''
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          autocomplete: {
              type: String,
              default: ''
          },
          autoGenerateOption: {
              type: Boolean,
              default: false
          },
          readable: {
              type: Boolean,
              default: false
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          }
      },
      watch: {
          value(val) {
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
          }
      },
      mounted() {
          this.dataValue = this.value
          if (this.readable) {
              this.dataType = 'text'
          }
      },
      data: () => {
          return {
              window: window,
              dataValue: '',
              dataType: 'password'
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          },
          generate() {
              this.dataValue = window.Core.Text.generateHash()
          }
      }
  }
</script>